import { IconButton, styled } from "@mui/material";

import { ReportWarningAlert } from "../ReportWarningAlert";

export const Alert = styled(ReportWarningAlert)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  marginLeft: 20,
  width: "100%",
  "& .MuiAlert-message": {
    width: "100%",
    padding: 0,
  },
}));

export const ShowWarningButton = styled(IconButton)(({ theme }) => ({
  // We use absolute positioning to place the icon next to the "Cost" header
  position: "absolute",
  top: -4,
  left: 72,
}));
